document.addEventListener('DOMContentLoaded', function() {
    var productsImage = new Swiper(`.products-image_slider`, {
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            dynamicBullets: true
        },
    });
    
    function handleFocus(e, i) {
      productsImage.slideTo(i);
    }
    
    // set slides as active on focus
    const slides = document.querySelectorAll('.products-image_slider');
    slides.forEach((slide, i) => slide.addEventListener('focusin', (e) => handleFocus(e, i)));
})